import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

///////////////////////////////////////////////////////////////////
// load XLS

export const PAYMENT_ORDERS_LOAD_TRIGGER = 'PAYMENT_ORDERS_LOAD_TRIGGER';
export interface PaymentOrdersLoadTriggerAction {
    readonly type: typeof PAYMENT_ORDERS_LOAD_TRIGGER;
    readonly xlsFile: File;
}

export const PAYMENT_ORDERS_LOAD_REQUEST = 'PAYMENT_ORDERS_LOAD_REQUEST';
export interface PaymentOrdersLoadRequestAction extends APIRequestAction {
    readonly type: typeof PAYMENT_ORDERS_LOAD_REQUEST;
}
export interface PaymentOrdersLoadNormalizedResponse extends NormalizedResponse {
    readonly result: { outputFilename: string, outputXML: string; };
}
export const PAYMENT_ORDERS_LOAD_SUCCESS = 'PAYMENT_ORDERS_LOAD_SUCCESS';
export interface PaymentOrdersLoadSuccessAction extends APISuccessAction<PaymentOrdersLoadNormalizedResponse> {
    readonly type: typeof PAYMENT_ORDERS_LOAD_SUCCESS;
}
export const PAYMENT_ORDERS_LOAD_FAILURE = 'PAYMENT_ORDERS_LOAD_FAILURE';
export interface PaymentOrdersLoadFailureAction extends APIFailureAction {
    readonly type: typeof PAYMENT_ORDERS_LOAD_FAILURE;
}

export const paymentOrdersLoadTrigger =
    (xlsFile: File): PaymentOrdersLoadTriggerAction => ({
        type: PAYMENT_ORDERS_LOAD_TRIGGER, xlsFile,
    });

export const paymentOrdersLoad = {
    request: (): PaymentOrdersLoadRequestAction => ({
        type: PAYMENT_ORDERS_LOAD_REQUEST,
    }),
    success: (response: PaymentOrdersLoadNormalizedResponse): PaymentOrdersLoadSuccessAction => ({
        type: PAYMENT_ORDERS_LOAD_SUCCESS, response,
    }),
    failure: (error: any): PaymentOrdersLoadFailureAction => ({
        type: PAYMENT_ORDERS_LOAD_FAILURE, error,
    }),
};
